import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import axiosInstance from "../../../utils/axios";
import { IErrorResponse } from "../../querys/querys.enum";
import { MutationKeys } from "../../mutation/mutation.enum";
import {
  SendSGTemplateEmailRequest,
  SendSGTemplateEmailResponse,
} from "../../../models/Interface/SGTemplate.interface";

const sendSGTemplateEmail = async (data: SendSGTemplateEmailRequest) => {
  const response = await axiosInstance.post<SendSGTemplateEmailResponse>(
    `/sg-template-management/send-email`,
    data
  );
  return response.data;
};

const useSendSGTemplateEmail = (
  options?: Partial<
    UseMutationOptions<
      SendSGTemplateEmailResponse,
      AxiosError<IErrorResponse>,
      SendSGTemplateEmailRequest
    >
  >
) => {
  return useMutation({
    mutationKey: [MutationKeys.SEND_SG_TEMPLATE_EMAIL],
    mutationFn: sendSGTemplateEmail,
    ...options,
  });
};

export default useSendSGTemplateEmail;
